export abstract class DialogProvider {
    abstract showErrorDialog<T>(error:any,next?: (value: T) => void): void;
    abstract showDeleteDialog<T>(data:any,next?: (value: T) => void): void;
}